import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-secondary-100 rounded-2xl">
            <i className="ri-error-warning-line text-4xl text-secondary-500"></i>
          </div>
          <h1 className="text-3xl md:text-5xl font-heading text-foreground-900 mb-3">404</h1>
          <p className="text-base text-foreground-500 mb-8">页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <i className="ri-arrow-left-line mr-2"></i>返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}